import React from "react";
import { IconButton, TableCell } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import { getIconLaboral } from "../ListadoSolicitud.iconMaps";

// Columna "Laborales": ícono de verificación laboral, con lápiz de editar
// (reasignar) si el usuario tiene permiso y la solicitud está en un estado
// elegible.
export default function CeldaLaboral({
  data,
  isError,
  verificacionSolicitud,
  permisoEditarVerificacionTerreno,
  permisoReasignarLaboral,
  handleOpenModalVerificacion,
  handleOpenDialogDomicilioLaboral,
  handlePopoverOpen,
}) {
  return (
    <TableCell align="center">
      <div>
        <span>
          <div className="relative inline-block">
            <IconButton
              onClick={() =>
                handleOpenModalVerificacion(data, "trabajo")
              }
              disabled={
                verificacionSolicitud(data) ||
                data.Laboral === false

              }
              size="small"
              sx={{
                opacity:
                  data.Laboral === false
                    ? 0
                    : 1,
                bgcolor: isError ? "#fee2e2" : "#f1f5f9",
                "&:hover": {
                  bgcolor: isError ? "#fca5a5" : "#e2e8f0",
                  transform: "scale(1.1)",
                },
                transition: "all 0.2s ease",
              }}
            >
              {getIconLaboral(data.idEstadoVerificacionTerrena)}
            </IconButton>
            {[1, 2, 6].includes(data.Estado) && data.idEstadoVerificacionTerrena === 0 && permisoEditarVerificacionTerreno()
              && (data.Laboral === false || (data.Laboral === true && permisoReasignarLaboral()))
              && (
                <EditIcon
                  onClick={() => handleOpenDialogDomicilioLaboral(data, "trabajo")}
                  className="absolute -top-5 -right-3 text-blue-600 cursor-pointer hover:text-blue-800 bg-white rounded-full shadow-sm p-0.5"
                  fontSize="small"
                />
              )}
          </div>

          {/* InfoIcon al lado del IconButton */}
          <span
            style={{
              // pointerEvents: estaDeshabilitado(data)
              //   ? "none"
              //   : "auto",
              // opacity: estaDeshabilitado(data) ? 0.5 : 1,
            }}
          >
            <MoreVertIcon
              onClick={(event) =>
                handlePopoverOpen(event, 5, data)
              }
              style={{ cursor: "pointer" }}
              className="text-slate-400 hover:text-slate-600 transition-colors duration-200"
            />
          </span>
        </span>


      </div>
    </TableCell>
  );
}
